import React from 'react'

export default function Footer({children, ...restProps}) {
    return (
        <div>
            <div sm={8} {...restProps}>{children}</div>
        </div>
    )
}